import { EnumRoutesAppWeb } from '../enum/EnumRoutesAppWeb';
import { DrawerActions, NavigationContainerRef, ParamListBase } from '@react-navigation/native';
import { createRef } from 'react';

export const navigationRef = createRef<NavigationContainerRef<ParamListBase>>();

export function navigate(name: string, params?: any) {
  navigationRef.current?.navigate(name, params);
}

export function goBack() {
  navigationRef.current?.goBack();
}

export function goHome() {
  navigationRef.current?.navigate(EnumRoutesAppWeb.dashboard);
}

export function toggleDrawer() {
  navigationRef.current?.dispatch(DrawerActions.toggleDrawer());
}
